import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './TransportRouteView.html?raw';
import { TiClassNames, TiEntities, TiInterfaces } from "../TiTypes";
import TiStage from './Stage';

class TiTransportRouteView extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private mainContainer: HTMLElement;

    private transportRoute: TiEntities.TransportRouteEntity;
    private stageEntities: Array<TiEntities.StageEntity>;


    private config: TiInterfaces.TiTransportRouteViewConfig = null;


    setTransportGood(transportGoodEntity: TiEntities.TransportGoodEntity,
        config?: TiInterfaces.TiTransportRouteViewConfig) {
        this.setData(transportGoodEntity.ref_transport_route, config)
    }
    setData(
        transportRoute: TiEntities.TransportRouteEntity,
        config?: TiInterfaces.TiTransportRouteViewConfig
    ) {

        if (config) this.setConfig(config);
        if (transportRoute) {
            this.transportRoute = transportRoute;
            if (transportRoute.EL_vt_route_transport_route) {
                this.stageEntities = lang.clone(transportRoute.EL_vt_route_transport_route);
            }

            this.drawData();        

        }
    }
   

    setConfig(config: TiInterfaces.TiTransportRouteViewConfig) {
        this.config = config;

        if (this.stageEntities?.length) {
            this.drawData();
        }
    }

    private drawData() {
        
        let tr = this.transportRoute;

        if (!tr) return;

        let targetNode = this.mainContainer;

        // ZEICHNEN: die Route insgesamt (Name, Teilstrecken-Slots)
        //this.UiModder.domConstruct.create("h5", {
        //    "innerHTML": "? transportweg titel",
        //    className: "title"
        //}, targetNode, "only");

        let sectionsContainer = this.UiModder.domConstruct.create("div", {
            className: "routeSectionsContainer flex_row_top"
        }, targetNode);

        //let container = this.createMainRouteContainer(mainRouteSlot);
        //this.UiModder.domConstruct.place(container, targetNode);

        for (let stageEntity of this.stageEntities) {

            if (stageEntity.Classname == TiClassNames.stage) {
                let view = new TiStage();

                view.setData(stageEntity, {
                    
                });

                view.placeAt(sectionsContainer);

                view.on("change", lang.hitch(this, this._onChange_Stage, stageEntity))

            }  else {
                continue;
            }
        }
    }

    private _onChange_Stage(stage: TiEntities.StageEntity) {
        this.emit("change", this.transportRoute);
    }


    //private createMainRouteContainer(data: TransportIntermodal.MainRouteTimeSlotEntity_Aliased) {

    //    let container = this.UiModder.domConstruct.create("div", { className: "slotInfoContainer round" });

    //    this.UiModder.domClass.add(container, data.Classname);

    //    let mainRouteSlot = <TransportIntermodal.MainRouteTimeSlotEntity_Aliased>data;

    //    this.UiModder.domConstruct.create("div", { className: "title", "innerHTML": mainRouteSlot.mainRouteName }, container);
    //    this.UiModder.domConstruct.create("div", { className: "description", "innerHTML": mainRouteSlot.name }, container);

    //    return container;
    //}


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.config = {
            sectionsConfig: {
                highlight: false,
                enableBookingStatus: false
            },
            highlightMode: "fadeAfterTarget"
        };
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);
    }
    startup() {
        super.startup.apply(this, arguments as any);
    }

}

export default mdsWidget(TiTransportRouteView);